export default __webpack_public_path__ + "static/media/geoserver-background.5e3ce1c0.jpg";